/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
export { i as chooseCity, a as clearStorage, c as clearStorageSync, b as datePicker, d as getDeviceId, e as getOrientation, f as getStatusBarHeight, g as getStorageSync, h as hideNavigationBarLoading, j as pauseAudio, k as playAudio, r as removeStorageSync, l as resumeAudio, m as setNavigationBar, n as setOrientation, s as setStorageSync, o as showNavigationBarLoading, p as stopAudio, q as uploadImage, t as vibrateLong, u as vibrateShort } from './index-e5fa4dec.js';
export { navigateTo } from './apis/navigate-to/index.js';
export { navigateBack } from './apis/navigate-back/index.js';
export { back } from './apis/back/index.js';
export { redirectTo } from './apis/redirect-to/index.js';
export { openInBrowser } from './apis/open-in-browser/index.js';
export { openOtherApp } from './apis/open-other-app/index.js';
export { isAppInstalled } from './apis/is-app-installed/index.js';
export { scan } from './apis/scan/index.js';
export { callPhone } from './apis/call-phone/index.js';
export { showSharePanel } from './apis/show-share-panel/index.js';
export { setClipboard } from './apis/set-clipboard/index.js';
export { getClipboard } from './apis/get-clipboard/index.js';
export { snapshot } from './apis/snapshot/index.js';
export { vibrate } from './apis/vibrate/index.js';
export { choosePhoneContact } from './apis/choose-phone-contact/index.js';
export { getLocation } from './apis/get-location/index.js';
export { getNetworkType } from './apis/get-network-type/index.js';
export { pay } from './apis/pay/index.js';
export { saveImage } from './apis/save-image/index.js';
export { chooseImage } from './apis/choose-image/index.js';
export { previewImage } from './apis/preview-image/index.js';
export { compressImage } from './apis/compress-image/index.js';
export { chooseAndUploadImage } from './apis/choose-and-upload-image/index.js';
export { saveVideo } from './apis/save-video/index.js';
export { chooseVideo } from './apis/choose-video/index.js';
export { previewVideo } from './apis/preview-video/index.js';
export { makeVideoChat } from './apis/make-video-chat/index.js';
export { uploadFile } from './apis/upload-file/index.js';
export { showToast } from './apis/show-toast/index.js';
export { hideToast } from './apis/hide-toast/index.js';
export { showLoading } from './apis/show-loading/index.js';
export { hideLoading } from './apis/hide-loading/index.js';
export { alert } from './apis/alert/index.js';
export { confirm } from './apis/confirm/index.js';
export { showActionSheet } from './apis/show-action-sheet/index.js';
export { setNaviBarRightItem } from './apis/set-navi-bar-right-item/index.js';
export { clearNaviBarRightItem } from './apis/clear-navi-bar-right-item/index.js';
export { setNavigationBarTitle } from './apis/set-navigation-bar-title/index.js';
export { showTitle } from './apis/show-title/index.js';
export { hideTitle } from './apis/hide-title/index.js';
export { setBackgroundColor } from './apis/set-background-color/index.js';
export { getStorage } from './apis/get-storage/index.js';
export { setStorage } from './apis/set-storage/index.js';
export { removeStorage } from './apis/remove-storage/index.js';
export { onGlobalResume } from './apis/on-global-resume/index.js';
export { onBackCatcher } from './apis/on-back-catcher/index.js';
export { g as getApp, b as getLaunchOptionsSync, o as onError, a as onUnhandledRejection } from './index-1a43174f.js';
export { getImageInfo } from './apis/get-image-info/index.js';
export { getInfo } from './apis/get-info/index.js';
import { l as lib } from './index-15359756.js';
export { getBoundingClientRect } from './apis/get-bounding-client-rect/index.js';
export { c as createIntersectionObserver } from './index-3601b531.js';
export { c as createAnimation, a as createTransition } from './index-eb99324a.js';
export { request } from './apis/request/index.js';
export { jsbridgeReady } from './apis/jsbridge-ready/index.js';
export { hideBack } from './apis/hide-back/index.js';
export { openSingleChat } from './apis/open-single-chat/index.js';
export { getAppBaseInfo } from './apis/get-app-base-infio/index.js';
export { playAdVideo } from './apis/play-ad-video/index.js';
export { preloadAdVideo } from './apis/preload-ad-video/index.js';
export { openSystemPush } from './apis/open-system-push/index.js';
export { openAmapApp } from './apis/open-amap-app/index.js';
export { utils } from './apis/utils/index.js';
export { env } from './apis/env/index.js';
export { configuration, extend } from './apis/extend/index.js';
export { pluginManager } from './apis/extend/plugin-manager/index.js';
export { loadAdapter } from './apis/extend/load-adapter/index.js';
import './tslib.es6-e01eabb2.js';
import './apis/navigate-to/cn/index.js';
import './bridges/windvane/index.js';
import './bridge-adpter-api-0316c034.js';
import './common-42e7d8d8.js';
import './safe-data-66f20265.js';
import './index-6f6b9acc.js';
import './_commonjsHelpers-56d33373.js';
import './apis/navigate-to/cnStation/index.js';
import './apis/navigate-to/tb/index.js';
import './apis/navigate-to/ali1688/index.js';
import './apis/navigate-to/fm/index.js';
import './apis/navigate-to/nebula/index.js';
import './bridges/nebula/index.js';
import './index.es-142c5680.js';
import './apis/navigate-to/dingTalk/index.js';
import './apis/navigate-to/dingTalkPC/index.js';
import './apis/navigate-to/mini/index.js';
import './index-ee2c9aee.js';
import './index-892d8eee.js';
import './apis/navigate-to/panguMiniApp/index.js';
import './bridges/pangu-mini-app/index.js';
import './loadscripts-cf212b8d.js';
import './constants-163bd007.js';
import './apis/navigate-back/cn/index.js';
import './apis/navigate-back/cnStation/index.js';
import './apis/navigate-back/fm/index.js';
import './apis/navigate-back/tm/index.js';
import './apis/navigate-back/tb/index.js';
import './apis/navigate-back/ali1688/index.js';
import './apis/navigate-back/browser/index.js';
import './apis/navigate-back/dingTalk/index.js';
import './apis/navigate-back/dingTalkPC/index.js';
import './apis/navigate-back/panguMiniApp/index.js';
import './apis/navigate-back/mini/index.js';
import './apis/back/web/index.js';
import './tool-7a8f4749.js';
import './apis/back/dingTalk/index.js';
import './apis/back/tb/index.js';
import './apis/redirect-to/dingTalk/index.js';
import './apis/redirect-to/ali1688/index.js';
import './apis/redirect-to/mini/index.js';
import './apis/open-other-app/cnStation/index.js';
import './apis/is-app-installed/cnStation/index.js';
import './apis/scan/cn/index.js';
import './apis/scan/cnStation/index.js';
import './apis/scan/tbLive/index.js';
import './apis/scan/dingTalk/index.js';
import './apis/scan/nebula/index.js';
import './apis/call-phone/cn/index.js';
import './apis/call-phone/web/index.js';
import './apis/call-phone/panguMiniApp/index.js';
import './apis/call-phone/mini/index.js';
import './apis/show-share-panel/cn/index.js';
import './apis/show-share-panel/cnStation/index.js';
import './apis/show-share-panel/tbLive/index.js';
import './apis/show-share-panel/nebula/index.js';
import './apis/show-share-panel/dingTalk/index.js';
import './apis/show-share-panel/panguMiniApp/index.js';
import './apis/set-clipboard/browser/index.js';
import './apis/set-clipboard/dingTalk/index.js';
import './apis/set-clipboard/panguMiniApp/index.js';
import './apis/set-clipboard/mini/index.js';
import './apis/get-clipboard/cn/index.js';
import './apis/snapshot/dingTalk/index.js';
import './apis/snapshot/panguMiniApp/index.js';
import './apis/vibrate/dingTalk/index.js';
import './apis/choose-phone-contact/dingTalk/index.js';
import './apis/get-location/cnStation/index.js';
import './apis/get-location/browser/index.js';
import './apis/get-location/dingTalk/index.js';
import './apis/get-location/panguMiniApp/index.js';
import './apis/get-location/mini/index.js';
import './apis/get-network-type/dingTalk/index.js';
import './apis/get-network-type/windvane/index.js';
import './apis/get-network-type/nebula/index.js';
import './apis/pay/cn/index.js';
import './apis/pay/cnStation/index.js';
import './apis/pay/tb/index.js';
import './apis/pay/nebula/index.js';
import './apis/pay/dingTalk/index.js';
import './apis/save-image/cnStation/index.js';
import './index-f24a9ec1.js';
import './apis/save-image/nebula/index.js';
import './apis/save-image/panguMiniApp/index.js';
import './apis/save-image/mini/index.js';
import './index-0bcce539.js';
import './apis/choose-image/panguMiniApp/index.js';
import './apis/choose-image/mini/index.js';
import './is-7fc17687.js';
import './apis/preview-image/cn/index.js';
import './apis/preview-image/dingTalk/index.js';
import './apis/preview-image/mini/index.js';
import './apis/compress-image/dingTalk/index.js';
import './apis/compress-image/panguMiniApp/index.js';
import './apis/compress-image/mini/index.js';
import './apis/save-video/cnStation/index.js';
import './apis/choose-video/panguMiniApp/index.js';
import './apis/preview-video/dingTalk/index.js';
import './apis/preview-video/panguMiniApp/index.js';
import './apis/make-video-chat/dingTalk/index.js';
import './apis/make-video-chat/panguMiniApp/index.js';
import './apis/upload-file/dingTalk/index.js';
import './apis/upload-file/panguMiniApp/index.js';
import './apis/show-toast/dingTalk/index.js';
import './apis/show-toast/cn/index.js';
import './apis/show-toast/ali1688/index.js';
import './index-48bf95da.js';
import './apis/show-toast/panguMiniApp/index.js';
import './apis/show-toast/mini/index.js';
import './apis/hide-toast/mini/index.js';
import './apis/show-loading/cn/index.js';
import './apis/show-loading/dingTalk/index.js';
import './apis/show-loading/panguMiniApp/index.js';
import './apis/hide-loading/cn/index.js';
import './apis/hide-loading/dingTalk/index.js';
import './apis/hide-loading/panguMiniApp/index.js';
import './apis/alert/dingTalk/index.js';
import './apis/alert/panguMiniApp/index.js';
import './apis/confirm/dingTalk/index.js';
import './apis/confirm/panguMiniApp/index.js';
import './apis/show-action-sheet/dingTalk/index.js';
import './apis/set-navi-bar-right-item/cn/index.js';
import './apis/set-navi-bar-right-item/cnStation/index.js';
import './apis/set-navi-bar-right-item/dingTalk/index.js';
import './apis/clear-navi-bar-right-item/cn/index.js';
import './apis/clear-navi-bar-right-item/cnStation/index.js';
import './apis/clear-navi-bar-right-item/dingTalk/index.js';
import './apis/set-navigation-bar-title/cn/index.js';
import './apis/set-navigation-bar-title/cnStation/index.js';
import './apis/set-navigation-bar-title/dingTalk/index.js';
import './apis/set-navigation-bar-title/browser/index.js';
import './apis/set-navigation-bar-title/panguMiniApp/index.js';
import './apis/set-navigation-bar-title/mini/index.js';
import './apis/show-title/cn/index.js';
import './apis/show-title/cnStation/index.js';
import './apis/hide-title/cn/index.js';
import './apis/hide-title/cnStation/index.js';
import './apis/get-storage/panguMiniApp/index.js';
import './apis/set-storage/panguMiniApp/index.js';
import './apis/remove-storage/panguMiniApp/index.js';
import './apis/on-back-catcher/cn/index.js';
import './apis/on-back-catcher/tb/index.js';
import './apis/on-back-catcher/ap/index.js';
import './apis/jsbridge-ready/nebula/index.js';
import './apis/hide-back/nebula/index.js';
import './apis/open-single-chat/dingTalk/index.js';
import './apis/play-ad-video/cn/index.js';
import './apis/preload-ad-video/cn/index.js';
import './apis/open-system-push/cn/index.js';
import './promise-windvane-85486cec.js';
import './apis/open-amap-app/web/index.js';
import './apis/open-amap-app/panguMiniApp/index.js';
import './bridges/dd/index.js';
import './apis/extend/register/index.js';
import './log-aabf3a34.js';

// 完全继承自uni-api。uni-api文档：https://uni-apis.alibaba-inc.com/doc/UI/showtoast
var VERSION = '2.9.0';

var getInfoSync = lib.getInfoSync;
export { VERSION, getInfoSync };
